import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";
import { NgModule } from "@angular/core";
import { NavbarComponent } from "src/app/components/navbar/navbar.component";
import { FirstAccessComponent } from "./components/first-access.component";

const routes: Routes = [
  {
    path: "primeiro-acesso",
    component: FirstAccessComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FirstAccessRoutingModule {}
